{{value | cbCurrency:gstMode | cbDasher}}